import axios from '@/axios/api.request'

export const save = (from) => axios.request({
    url: '/software/settle/save',
    data: from,
    method: 'post'
  })

  export const pay = (from) => axios.request({
    url: '/software/settle/pay',
    data: from,
    method: 'post'
  })

  export const batchPay = (from) => axios.request({
    url: '/software/settle/batchPay',
    data: from,
    method: 'post'
  })